 $(window).scroll(function() {
          if ($(this).scrollTop() > 50) {
              $('.template-collection').addClass('has-scrolled');
          } else {
              $('.template-collection').removeClass('has-scrolled');
          }
      });

         $('document').ready(function(){
             $('.input--full.personlization_text').on('input', function(){
                 var text = $(this).val()
              $('.product-custom-option').text(text)
            })
                   });
                 $('.admin__field-label').click(function(){
                 	var font = $(this).find('span').text();
                   console.log(font)
                 	$('.app_variant_id').attr('value', font)

            $('.input--full.personlization_text').on('input', function(){
              var text_value = $(this).val()
              $('.text_value').attr('value', text_value)
            })
                 });
      //       $(document).ready(function (){
      //   if(window.location.href.includes('/collections/ilwu')){
      //     alert("yes");
      //     $(".itg_banner_columns").hide();
      //   }
      // });



/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
